import { route } from '../../../utils'
import links from '../../../links.json'
import { MODEL_TYPE_KEY_BY_VALUE } from '../../../constants/index.jsx'
import { useTranslation } from 'react-i18next'

export default function NewDocumentHeaders ({ newDocumentHeaders }) {
  const { t } = useTranslation()

  const contentRender = []

  newDocumentHeaders.forEach(newDocumentHeader => {
    const newDocumentCode = MODEL_TYPE_KEY_BY_VALUE(newDocumentHeader.type).toLowerCase()
    const newDocumentLabel = t(`labels.${newDocumentCode}`)
    const newDocumentRoute = route(links.documents.edit, {
      documentTypeBind: newDocumentCode.replace(/_/g, '-'),
      documentHeader: newDocumentHeader.id
    })

    contentRender.push(
      <a
        href={newDocumentRoute} target='_blank'
        rel='noreferrer'
        key={`info-${newDocumentHeader.id}`}
        className='flex'
      >
        {newDocumentLabel}: #{newDocumentHeader.no}
      </a>
    )
  })

  return (
    <div className='text-sm py-4 text-center'>
      {contentRender}
    </div>
  )
}
